import * as stylex from "@stylexjs/stylex";
import {
  colors,
  fontSizes,
  spacing,
} from "@softmax/design-system/tokens.stylex";
export const layoutStyles = stylex.create({
  grid: {
    display: "grid",
    gridTemplateColumns: "minmax(0, 1fr)",
    gap: spacing.space32,
  },
  withRail: {
    gridTemplateColumns: {
      default: "minmax(0, 1fr)",
      "@media (min-width: 1024px)": "minmax(0, 1fr) 18rem",
    },
    gap: spacing.space32,
  },
  rail: {
    borderTopWidth: { default: 1, "@media (min-width: 1024px)": 0 },
    borderTopStyle: "solid",
    borderTopColor: colors.border,
    borderLeftWidth: { default: 0, "@media (min-width: 1024px)": 1 },
    borderLeftStyle: "solid",
    borderLeftColor: colors.border,
    paddingTop: { default: spacing.space24, "@media (min-width: 1024px)": 0 },
    paddingLeft: { default: 0, "@media (min-width: 1024px)": spacing.space32 },
    display: "flex",
    flexDirection: "column",
    gap: spacing.space32,
    alignSelf: "start",
  },
  railHeading: {
    margin: 0,
    marginBottom: spacing.space8,
    color: colors.muted,
    fontSize: fontSizes.caption,
    fontWeight: 600,
    textTransform: "uppercase",
    letterSpacing: "0.06em",
  },
  railDescription: {
    margin: 0,
    marginBottom: spacing.space12,
    color: colors.subtle,
    fontSize: fontSizes.reading,
    lineHeight: 1.5,
  },
  railList: {
    listStyle: "none",
    padding: 0,
    margin: 0,
    marginBottom: spacing.space12,
    display: "flex",
    flexDirection: "column",
    gap: spacing.space8,
  },
});
